import React, { Children, cloneElement } from 'react';
import { TabbedShowLayout, TabbedShowLayoutTabs } from 'react-admin';
import Paper from '@material-ui/core/Paper';
import makeStyles from '@material-ui/core/styles/makeStyles';
import cx from 'classnames';
import { useEditMode, useEditModeStyles } from '~/hooks/useEditModeContext';

const useStyles = makeStyles(() => ({
  fullWidthGrow: {
    flexGrow: 1,
    width: '100%',
  },
  root: {
    boxSizing: 'border-box',
    flexGrow: 1,
    minWidth: 800,
  },
  TabbedShowLayout: {
    display: 'grid',
  },
}));

interface Props {
  bottomContent?: any;
  [x: string]: any;
}

const PaperTabbedShowLayout = (props: Props) => {
  const { bottomContent, ...rest } = props;
  const classes = useStyles();
  const { editMode } = useEditMode();
  const editModeClasses = useEditModeStyles({ editMode });
  return (
    <div className={classes.fullWidthGrow}>
      <Paper className={classes.root}>
        <TabbedShowLayout
          tabs={<TabbedShowLayoutTabs variant='scrollable' {...sanitizeProps(rest)} />}
          {...rest}
          className={cx(classes.TabbedShowLayout, editModeClasses.backgroundColor)}
        />
      </Paper>
      {bottomContent &&
        Children.toArray(bottomContent).map((element: any) => cloneElement(element, { ...rest }))}
    </div>
  );
};

const sanitizeProps = (props: any) => {
  const { basePath, ...rest } = props; // eslint-disable-line @typescript-eslint/no-unused-vars
  return rest;
};

export default PaperTabbedShowLayout;
